module.exports = __webpack_public_path__ + "img/icon-telefon.551ecbe8.svg";